<template>
  <div>
    <MainTitle title="知识分享" path="course/list" :titleImg="require('@/assets/sixf.png')"/>
    <div class="content">  <!-- v-loading="loading"-->
      <div v-if="loading">
        <el-row :gutter="20">
          <el-col :span="6" :key="index" v-for="(item) in 12" style="margin: 10px 0;">
            <el-skeleton style="width: 100%;border: 1px solid #eee">
              <template slot="template" style="">
                <el-skeleton-item variant="image" style="width: 100%; height: 233px;" />
                <el-skeleton-item variant="text" style="width: 100px" />
                <div style="display: flex;padding: 5px">
                  <div>
                    <el-skeleton-item variant="image" style="width: 30px; height: 30px;" />
                  </div>
                  <div style="flex: 1">
                    <el-skeleton-item variant="text" style="width: 100px;float: right" />
                  </div>
                </div>
              </template>
            </el-skeleton>
          </el-col>
        </el-row>
      </div>
      <div>
        <el-row :gutter="20">
          <el-col :span="6" v-for="(item,index) in list" :key="index">
            <card :item="item" :type="1"></card>
          </el-col>
        </el-row>
        <paging :sq="this.param.page>1" :gd="list.length<this.param.total" @pageupdata="pageupdata"></paging>
      </div>
      <!-- 无数据 -->
      <BaseEmptyData v-if="!list.length && !loading"></BaseEmptyData>
    </div>
  </div>
</template>

<script>
import cookie from "@/storage/cookies"
import { apiTechnologyShare } from "@/api/apiTechnologyShare"

export default {
  name: "technologyShare",
  components: {
    MainTitle: () => import("@/views/Home/AllComponents/MainTitle"), // 头部组件
    BaseEmptyData: () => import("@/components/public/BaseEmptyData"), // 无数据组件
    paging: () => import("./paging"), // 分页组件
    card:()=>import("@/components/card/cardTechnologyShare.vue") // 技术分享card
  },
  data(){
    return {
      type:'0',
      list:[],
      param:{
        page: 1,
        limit: 12,
        total:0
      },
      code:{},
      loading:true
    }
  },
  created() {
    this.tabSelect({type:'0'});
  },
  methods:{
    pageupdata(v){
      if(v)this.param.page=v
      else this.param.page++;
      this.getlist();
    },
    tabSelect(v){
      this.type=v.type;
      //参数封装
      let code={}
      let cookieArea = cookie.cookieRead("area");
      let area = cookieArea ? JSON.parse(cookieArea) : null
      if(area)code.provinceNo = area.id
      this.func = apiTechnologyShare.GetShareList
      //参数重置
      this.code=code;
      this.param.page=1;
      this.getlist();
    },
    //获取数据列表
    async getlist(){
      if(this.param.page==1){
        this.list=[];
        this.param.total=0;
      }
      this.loading=true;
      let param={...this.param,...this.code}
      if(this.type==3){
        param.pageNum=param.page
        param.pageSize=param.limit
      }
      let res=await this.func(param)
      if (res.data && res.data.code === 200){
        this.loading=false;
        if(this.param.page==1)this.list=res.data.data.records;
        else this.list=this.list.concat(res.data.data.records)
        this.param.total=res.data.data.total
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .content{
    width: 1200px;
    min-height: 200px;
    padding: 0 20px;
    background: #fff;
    box-sizing: border-box;
    margin: auto;
    /deep/.empty-data{
      padding: 0 0 20px;
    }
    /deep/ .hideBox {
      display: none !important;
    }
    /deep/ .card:hover{
      border: 1px solid #0286df;
    }
  }
</style>
